import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-wizard', 'completedStep', 'Užbaigtas žingsnis');
Labels.set('ui-wizard', 'next', 'Kitas');
Labels.set('ui-wizard', 'back', 'Atgal');
